import EstimateCard from "@molecules/ObjectCard/ObjectCards/EstimateCard/EstimateCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function EstimateCardsView() {
    return (
        <CardsView.List<Estimate>>
            {(estimate, displayedAttributes) => (
                <EstimateCard estimate={estimate} displayedAttributes={displayedAttributes} />
            )}
        </CardsView.List>
    )
}
